<template>
  <section class="sceneDetailProcess">
    <header-com isTransparent></header-com>
    
    <swiper :options="swiperOption" ref="mySwiper" class="mySwiper">
      <swiper-slide  class="slideItem">
        <img class="ani slide1_img0"
             swiper-animate-effect="fadeInRightBig"
             swiper-animate-duration=".8s"
             swiper-animate-delay="-.2s"
             src="/images/sceneDetail/1.0.png"
             width="235px" alt=""/>
        <img class="ani slide1_img1"
             swiper-animate-effect="fadeInRightBig"
             swiper-animate-duration=".8s"
             swiper-animate-delay="0s"
             src="/images/sceneDetail/1.1.png"
             width="290px" alt=""/>
        <img class="ani slide1_img2"
             swiper-animate-effect="fadeInRightBig"
             swiper-animate-duration="1s"
             swiper-animate-delay=".2s"
             src="/images/sceneDetail/1.2.png"
             width="100px" alt=""/>
        <img class="ani slide1_img3"
             swiper-animate-effect="bounceInRight"
             swiper-animate-duration=".8s"
             swiper-animate-delay=".5s"
             src="/images/sceneDetail/1.3.png"
             width="100px"  alt=""/>
        <img class="ani slide1_img4"
             swiper-animate-effect="bounceInRight"
             swiper-animate-duration=".8s"
             swiper-animate-delay=".5s"
             src="/images/sceneDetail/1.4.png"
             width="176px"  alt=""/>
      </swiper-slide>
      <swiper-slide  class="slideItem">
        <img class="ani slide2_img0"
             swiper-animate-effect="fadeInRightBig"
             swiper-animate-duration=".8s"
             swiper-animate-delay="-.2s"
             src="/images/sceneDetail/2.0.png"
             width="235px" alt=""/>
        <img class="ani slide2_img1"
             swiper-animate-effect="fadeInRightBig"
             swiper-animate-duration=".8s"
             swiper-animate-delay="0s"
             src="/images/sceneDetail/2.1.png"
             width="270px" alt=""/>
        <img class="ani slide2_img2"
             swiper-animate-effect="fadeInRightBig"
             swiper-animate-duration="1s"
             swiper-animate-delay=".2s"
             src="/images/sceneDetail/2.2.png"
             width="100px" alt=""/>
        <img class="ani slide2_img3"
             swiper-animate-effect="fadeInRightBig"
             swiper-animate-duration=".8s"
             swiper-animate-delay=".5s"
             src="/images/sceneDetail/2.3.png"
             width="215px"  alt=""/>
      </swiper-slide>
      <swiper-slide  class="slideItem">
        <img class="ani slide3_img0"
             swiper-animate-effect="fadeInRightBig"
             swiper-animate-duration=".8s"
             swiper-animate-delay="-.2s"
             src="/images/sceneDetail/3.0.png"
             width="235px" alt=""/>
        <img class="ani slide3_img1"
             swiper-animate-effect="fadeInRightBig"
             swiper-animate-duration="1s"
             swiper-animate-delay="0s"
             src="/images/sceneDetail/3.1.png"
             width="230px" alt=""/>
        <img class="ani slide3_img2"
             swiper-animate-effect="fadeInRightBig"
             swiper-animate-duration="1s"
             swiper-animate-delay=".3s"
             src="/images/sceneDetail/3.2.png"
             width="79px" alt=""/>
        <img class="ani slide3_img3"
             swiper-animate-effect="fadeInRightBig"
             swiper-animate-duration=".8s"
             swiper-animate-delay="1s"
             src="/images/sceneDetail/3.3.png"
             width="63.5px"  alt=""/>
        <img class="ani slide3_img4"
             swiper-animate-effect="fadeInRightBig"
             swiper-animate-duration=".8s"
             swiper-animate-delay=".8s"
             src="/images/sceneDetail/3.4.png"
             width="111px"  alt=""/>
        <img class="ani slide3_img5"
             swiper-animate-effect="fadeInRightBig"
             swiper-animate-duration=".8s"
             swiper-animate-delay=".5s"
             src="/images/sceneDetail/3.5.png"
             width="256px"  alt=""/>
      </swiper-slide>
      <swiper-slide  class="slideItem">
        <img class="ani slide4_img0"
             swiper-animate-effect="fadeInRightBig"
             swiper-animate-duration=".8s"
             swiper-animate-delay="-.2s"
             src="/images/sceneDetail/4.0.png"
             width="235px" alt=""/>
        <img class="ani slide4_img1"
             swiper-animate-effect="fadeInRightBig"
             swiper-animate-duration="1s"
             swiper-animate-delay="0s"
             src="/images/sceneDetail/4.1.png"
             width="272.5px" alt=""/>
        <img class="ani slide4_img2"
             swiper-animate-effect="fadeInRightBig"
             swiper-animate-duration="1s"
             swiper-animate-delay=".2s"
             src="/images/sceneDetail/4.2.png"
             width="235px" alt=""/>
        <img class="ani slide4_img3"
             swiper-animate-effect="fadeInRightBig"
             swiper-animate-duration="1s"
             swiper-animate-delay=".5s"
             src="/images/sceneDetail/4.3.png"
             width="75px"  alt=""/>
        <img class="ani slide4_img4"
             swiper-animate-effect="fadeInRightBig"
             swiper-animate-duration=".8s"
             swiper-animate-delay=".8s"
             src="/images/sceneDetail/4.4.png"
             width="101px"  alt=""/>
        <img class="ani slide4_img5"
             swiper-animate-effect="fadeInRightBig"
             swiper-animate-duration=".8s"
             swiper-animate-delay=".8s"
             src="/images/sceneDetail/4.5.png"
             width="235px"  alt=""/>
      </swiper-slide>
      <swiper-slide  class="slideItem">
      <img class="ani slide5_img0"
           swiper-animate-effect="fadeInRightBig"
           swiper-animate-duration=".8s"
           swiper-animate-delay="-.2s"
           src="/images/sceneDetail/5.0.png"
           width="235px" alt=""/>
      <img class="ani slide5_img1"
           swiper-animate-effect="fadeInRightBig"
           swiper-animate-duration=".8s"
           swiper-animate-delay="0s"
           src="/images/sceneDetail/5.1.png"
           width="216px" alt=""/>
      <img class="ani slide5_img2"
           swiper-animate-effect="fadeInRightBig"
           swiper-animate-duration="1s"
           swiper-animate-delay=".2s"
           src="/images/sceneDetail/5.2.png"
           width="224px" alt=""/>
      <img class="ani slide5_img3"
           swiper-animate-effect="fadeInRightBig"
           swiper-animate-duration=".8s"
           swiper-animate-delay=".5s"
           src="/images/sceneDetail/5.3.png"
           width="264px"  alt=""/>
      <img class="ani slide5_img4"
           swiper-animate-effect="fadeInRightBig"
           swiper-animate-duration=".8s"
           swiper-animate-delay=".5s"
           src="/images/sceneDetail/5.4.png"
           width="158px" alt=""/>

    </swiper-slide>
      <swiper-slide  class="slideItem last">
      <!--查看更多-->
      </swiper-slide>
      <!--<div class="swiper-pagination" slot="pagination"></div>-->
    </swiper>
    
    <div class="btn" v-show="isShowBtn" @click="$router.push({name:'proList'})">
      <img src="/images/sceneDetail/6.0.png" align="middle">
    </div>
    
  </section>
  
</template>

<script>
  // import Swiper from 'vue-awesome-swiper'
  // window.Swiper = Swiper
  import * as swiperAni from '@utils/swiper.animate.min'
  import 'animate.css'
  export default {
    name: "sceneDetailProcess",
    components: {},
    data() {
      const _this = this;
      return {
        isShowBtn:false,
        swiperOption: {
          slidesPerView: 'auto',
          // loop:true,
          // pagination: {
          //   el: '.swiper-pagination',
          //   dynamicBullets: true
          // },
          on:{
            init: function(){
              swiperAni.swiperAnimateCache(this); //隐藏动画元素
              swiperAni.swiperAnimate(this); //初始化完成开始动画
              this.slides.eq(0).find('.ani').removeClass('ani');
            },
            slideChangeTransitionEnd: function(){
              swiperAni.swiperAnimate(this); //每个slide切换结束时也运行当前slide动画
              this.slides.eq(this.activeIndex).find('.ani').removeClass('ani'); //动画只展现一次，去除ani类名
            },
            reachEnd(){
              this.slideTo(4);
              _this.isShowBtn=true
              // console.log(1)
            }
          }
        },
      }
    },
    watch: {},
    computed: {
      mySwiper() {
        return this.$refs.mySwiper.swiper
      }
    },
    created() {
    },
    mounted() {
    },
    methods: {}

  }
</script>

<style lang="scss" scoped>
.sceneDetailProcess{
  height: 100%;
  .mySwiper{
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top:0;
    .slideItem{
      width: 100%;
      height: 100%;
      /*<!--background: $brand-color;-->*/
      position: relative;
      img{
        position: absolute;
        z-index: 10;
      }
      /*第一幕*/
      .slide1_img0{
        left: 145px;
        top:155px
      }
      .slide1_img1{
        left: 87px;
        top:490px
      }
      .slide1_img2{
        left: 470px;
        top:760px
      }
      .slide1_img3{
        left: 519px;
        top:620px
      }
      .slide1_img4{
        left: 200px;
        top:1160px
      }
      /*第二幕*/
      .slide2_img0{
        left: 145px;
        top:155px
      }
      .slide2_img1{
        left: 105px;
        top:360px
      }
      .slide2_img2{
        left: 80px;
        top:760px
      }
      .slide2_img3{
        left: 160px;
        top:1160px
      }
      /*第第三幕*/
      .slide3_img0{
        left: 145px;
        top:155px
      }
      .slide3_img1{
        left: 80px;
        top:440px
      }
      .slide3_img2 {
        left: 232px;
        top: 580px
      }
      .slide3_img3 {
        left: 565px;
        top: 830px
      }
      .slide3_img4 {
        left: 423px;
        top: 680px
      }
      .slide3_img5{
        left: 116px;
        top:1160px
      }
      /*第四幕*/
      .slide4_img0{
        left: 145px;
        top:155px
      }
      .slide4_img1 {
        left: 114px;
        top: 265px
      }
      .slide4_img2 {
        left: 105px;
        top: 715px
      }
      .slide4_img3 {
        left: 171px;
        top: 425px
      }
      .slide4_img4 {
        left: 437px;
        top: 760px
      }
      .slide4_img5 {
        left: 150px;
        top: 1160px
      }
  
      /*第五幕*/
      .slide5_img0{
        left: 145px;
        top:155px
      }
      .slide5_img1 {
        left: 65px;
        top: 550px
      }
      .slide5_img2 {
        left: 292px;
        top: 400px
      }
      .slide5_img3{
        left: 104px;
        top: 720px
      }
      .slide5_img4{
        left: 217px;
        top: 1160px
      }
    }
    .last{
      width:100px;
    }
  }
  

  .btn{
    position: fixed;
    right: 0;
    top:400px;
    z-index: 10;
    border-radius:  20px 0 0 20px;
    overflow: hidden;
    img{
      width: 100px;
    }
    
  }
}
</style>
